import Icons from "assets";
import { TouchpointType } from "types/touchpoint";

/** The headline glyph for a touchpoint dialog; `Dialog` sizes and colours it. */
const TouchpointModalIcon = ({ type }: { type: TouchpointType }) =>
  type === TouchpointType.OTHER ? <Icons.Other /> : <Icons.LandingPage />;

export default TouchpointModalIcon;
